import * as React from 'react';

// export function CommonPreview() {
//     return [
//         <h3 key={ "h3" }>{ 'Lorem ipsum dolor sit amet' }</h3>,
//         <p key={ "p1" }>
//             { 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.' }
//         </p>,
//         <p key={ "p2" }>
//             { 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.' }
//         </p>
//     ];
// }

export function CommonPreview(glob, _theme) {
    return [
        <div key="common-preview" className="p-3" style={{ backgroundColor: _theme['body-bg'] }}>
            <div className="border shadow">
                <div
                    className="p-2"
                    style={{
                        color: _theme['on-primary'],
                        backgroundColor: _theme['primary-bg']
                    }}
                >
                    <h3>Primary</h3>
                    <p key={'p1'}>
                        {
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
                        }
                    </p>
                </div>
                <div
                    className="p-2"
                    style={{
                        color: _theme['on-secondary'],
                        backgroundColor: _theme['secondary-bg']
                    }}
                >
                    <h3>Secondary</h3>
                    <p key={'p1'}>
                        {
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
                        }
                    </p>
                </div>
                <div
                    className="p-2"
                    style={{
                        color: _theme['gray-base'],
                        backgroundColor: _theme['surface-bg']
                    }}
                >
                    <h3>Surface</h3>
                    <p key={'p1'}>
                        {
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
                        }
                    </p>
                </div>
            </div>

            <button className="btn btn-success" key="brand-preview-2">
                {'Success Button'}
            </button>

            <button className="btn btn-info" key="brand-preview-3">
                {'Info Button'}
            </button>

            <button className="btn btn-danger" key="brand-preview-4">
                {'Danger Button'}
            </button>
        </div>
    ];
}
